import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { take, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
  BaseAbstractFiltersAndActionsClass,
  BaseFilterService,
  BaseInquiryOfferOrderDirection,
  BaseInquiryOfferOrderKey,
  BaseInquiryService,
  PspBranchFilterInfoResponse,
  QualificationShortInfoResponse,
  baseSharedSelectors,
  baseSharedActions,
  BaseRolesService,
  BASE_PERMISSIONS,
  BaseQueryParamService,
} from 'base';
import { BaseCustomerInquiryOffersSortKeysInterface } from '../../_interfaces/base-customer-inquiry-offers-sort-keys.interface';
import { BaseCustomerInquiryOffersFiltersOptionsConst } from '../../_const/base-customer-inquiry-offers-filters-options.const';

@Component({
  selector: 'base-customer-offers-search-and-legend',
  templateUrl: './base-customer-offers-search-and-legend.component.html',
})
export class BaseCustomerOffersSearchAndLegendComponent extends BaseAbstractFiltersAndActionsClass implements OnInit {
  @Input() activeSortOrderDirection: BaseInquiryOfferOrderDirection | undefined;
  @Input() activeSortOrderKey: BaseInquiryOfferOrderKey | undefined;
  @Input() branches: PspBranchFilterInfoResponse[];
  @Input() mainQualifications: QualificationShortInfoResponse[];
  @Input() isFiltersVisible = false;
  @Input() filtersForm: FormGroup;
  @Input() widgetTemplate: TemplateRef<any>;
  @Output() sortItemClicked: EventEmitter<BaseCustomerInquiryOffersSortKeysInterface> =
    new EventEmitter<BaseCustomerInquiryOffersSortKeysInterface>();
  @Output() searchChange = new EventEmitter<string | undefined>();

  isLegendVisible = false;
  legend: { status: string; icon: string }[];
  baseInquirySortingOptions = BaseCustomerInquiryOffersFiltersOptionsConst;
  activeSortFilterLabel: string | undefined;
  activeFiltersAmount: number;
  canPreselectOffers: boolean;

  constructor(
    public filterService: BaseFilterService,
    public baseInquiryService: BaseInquiryService,
    private store: Store,
    private rolesService: BaseRolesService,
    public queryParamsService: BaseQueryParamService,
    public activatedRoute: ActivatedRoute
  ) {
    super(baseInquiryService, filterService, queryParamsService, activatedRoute);
  }

  ngOnInit() {
    this.getActiveSortFilterValue();
    this.canPreselectOffers = this.rolesService.hasCustomerFeaturePermission(BASE_PERMISSIONS.FEATURE_PRESELECT_OFFERS);
    this.legend = this.canPreselectOffers
      ? [
          { status: 'offerRejected', icon: 'offerRejected' },
          { status: 'offerSelected', icon: 'offerSelected' },
          { status: 'booked', icon: 'offerBooked' },
          { status: 'needsConfirmation', icon: 'needsConfirmation' },
          { status: 'offeredByProvider', icon: 'offeredByProvider' },
        ]
      : [
          { status: 'offerSelected', icon: 'offerSelected' },
          { status: 'booked', icon: 'offerBooked' },
          { status: 'needsConfirmation', icon: 'needsConfirmation' },
          { status: 'offeredByProvider', icon: 'offeredByProvider' },
        ];

    this.store
      .select(baseSharedSelectors.getSidebarInitialOpening)
      .pipe(
        take(1),
        filter((value) => !!value)
      )
      .subscribe((value) => {
        this.showSidebar();
        this.store.dispatch(baseSharedActions.setSidebarInitialOpening({ payload: false }));
      });
  }

  showFilters(): void {
    this.isFiltersVisible = !this.isFiltersVisible;
    this.isLegendVisible = false;
    this.activeFiltersAmount = this.filterService.updateActiveFilters(this.filtersForm.value).length;
  }

  showLegend(): void {
    this.isLegendVisible = !this.isLegendVisible;
    this.isFiltersVisible = false;
  }

  onSortItemClicked($event: BaseCustomerInquiryOffersSortKeysInterface): void {
    this.sortItemClicked.emit($event);
  }

  private getActiveSortFilterValue(): void {
    const activeSortFilterItem = this.baseInquirySortingOptions.find(
      (item) => item.orderKey === this.activeSortOrderKey
    );
    this.activeSortFilterLabel = activeSortFilterItem?.name;
  }
}
